import React, { useEffect, useState } from "react";
import { useContext } from "react";
import {
  useLeadAndProscpect,
} from "../../context/apiContext/Lead-and-ProspectContext";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import PageLoading from "../../components/Loading/PageLoading";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import { Card, CardHeader, ListItemIcon, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import {
  allLeadprospect,
} from "../../lib/graphQL/graphQuery";

import request, { gql } from "graphql-request";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import "./leadbar.css";
import TableComponent from "../../components/GridTable/TableComponent";


const getLeadprospectDetailByUser = gql`
  query getLeadprospectDetailByUser($id: String!) {
    getLeadprospectDetailByUser(id: $id) {
      id
      prsid
      firstName
      lastName
      companyName
      leadSource
      
      
      user {
        username
      }
      createdAt
    }
  }
`;
const getLeadprospectDetailByMaster = gql`
query getLeadprospectDetailByMaster($id: String!) {
    getLeadprospectDetailByMaster(id: $id) {
      id
      prsid
      companyName
      leadSource
      
      
      user {
        username
      }
      createdAt
    }
  }
`;
const LeadAndProspect = () => {
  const { leadData, setLeadData, isLoading, setIsLoading, status, setStatus } =
    useLeadAndProscpect();
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(false);

    if (isUser.toLowerCase() == "employee") {
      fetchEmployeeData()

    }
    else if (isUser.toLowerCase() == "manager") {
      fetchMangerData()
    }
    else if (isUser.toLowerCase() == "superuser") {
      fetchallData()
    } 
    else {
      setLeadData([])
    }
  }, []);


  const fetchallData = () => {
    setIsLoading(true);
    request(BASEURL, allLeadprospect, { id: currentUser?.id })
      .then((res) => setLeadData(res?.allLeadprospect))
      .finally(() => { setIsLoading(false); });
  }
  const fetchEmployeeData = () => {
    setIsLoading(true);
    request(BASEURL, getLeadprospectDetailByUser, { id: currentUser?.id })
      .then((res) => setLeadData(res?.getLeadprospectDetailByUser))
      .finally(() => { setIsLoading(false); });
  }
  const fetchMangerData = () => {
    setIsLoading(true);
    request(BASEURL, getLeadprospectDetailByMaster, { id: currentUser?.id })
      .then((res) => setLeadData(res?.getLeadprospectDetailByMaster))
      .finally(() => { setIsLoading(false); });
  }
  const customerListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S.no",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Prospect ID",
        field: "prsid",
        name: "Prospect ID",
        flex: 1,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Organization Name",
        field: "companyName",
        name: "Company Name",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Prospect Source",
        field: "leadSource",
        name: "Prospect Source",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: leadData
      .sort((a, b) => Number(b.id) - Number(a.id))
      .map((item, index) =>
      // console.log("rows:", rows),
      ({
        sno: index + 1,
        id: item.id,
        prsid: item.prsid,
        firstName: item.firstName,
        lastName: item.lastName,
        companyName: item.companyName,
        leadSource: item.leadSource,
        Status: (
          <>
            <div style={{ marginTop: "10px" }}>
              {item.status}
              <div className="bar-mainbox">
                {item.status?.toLowerCase() == "new" && (
                  <div style={{ width: "35%" }}></div>
                )}
                {item.status?.toLowerCase() == "in progress" && (
                  <div style={{ width: "65%" }}></div>
                )}
                {item.status?.toLowerCase() == "done" && (
                  <div style={{ width: "100%" }}></div>
                )}
              </div>
            </div>
          </>
        ),
        createdBy: item.user.username,
        createdAt: item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
      })
      )
      .sort((a, b) => Number(b.id) - Number(a.id)),
  };

  const handleAddLeadForm = () => {
    navigate("/prospect/add-Prospect");
  };

  const onLeadAndProscpectClick = (e) => {
    if (e?.id) {
      navigate(`/prospect/add-Prospect?${e?.id}`);
    }
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }
  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false }
      columns={customerListTable.columns}
      rowsData={customerListTable.rows}
      head="Prospect List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onLeadAndProscpectClick}
      // onDelete={onDelete}
      onView={onLeadAndProscpectClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleAddLeadForm()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Prospect List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddLeadForm()}
              >
                Add Prospect
              </MaterialButton>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={customerListTable.rows}
            columns={customerListTable.columns}
            //checkboxSelection={true}
            onRowClick={onLeadAndProscpectClick}
            disableColumnMenu={true}
          />
        )}

        {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
};

export default LeadAndProspect;
